// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"627756db","839":"fc8e1712"}[chunkId] + ".chunk.js";
};